import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './DesktopFiltersHeader.styles';
import { useServerDataContext } from '@/contexts';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { ROOT_CATEGORY_SLUG } from '@/constants/common';

interface Props {
  filtersCount?: number;
  isResetButtonDisabled: boolean;
}

export const DesktopFiltersHeader: FC<Props> = ({
  filtersCount,
  isResetButtonDisabled,
}) => {
  const { t } = useTranslation();
  const { currentCategory: serverCurrentCategory } = useServerDataContext();
  const { currentCategory = serverCurrentCategory } = useCurrentCategory();
  return (
    <S.Container>
      <S.Title>
        {t('common.filters')} {filtersCount ? `(${filtersCount})` : ''}
      </S.Title>
      <S.ResetButton
        disabled={isResetButtonDisabled}
        as={CustomLink}
        href={`/${currentCategory?.path ?? ROOT_CATEGORY_SLUG}`}
      >
        {t('common.reset')}
      </S.ResetButton>
    </S.Container>
  );
};
